import React from 'react';
import { FaGripHorizontal, FaCalendar, FaCog, FaFile, FaUser, FaUserPlus } from 'react-icons/fa';
import {FiLogOut } from 'react-icons/fi';
import { NavLink} from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {

    return (
        <div className='sidebar  pt-5'>
            <NavLink exact to='/dashboard' className='ms-4 text-white'>
                <FaGripHorizontal/> 
                <span className='ms-2'>Dashboard</span> 
            </NavLink>
            <NavLink exact to='/dashboard/appointments' className='ms-4 text-white'>
                <FaCalendar/> 
                <span className='ms-2'>Appointments</span> 
            </NavLink>
            <NavLink exact to='/dashboard/patients' className='ms-4 text-white'>
                <FaUser/> 
                <span className='ms-2'>Patients</span> 
            </NavLink>
            <NavLink exact to='/dashboard/prescriptions' className='ms-4 text-white'>
                <FaFile/> 
                <span className='ms-2'>Prescriptions </span>
            </NavLink>
            <NavLink exact to='/dashboard/addDoctor' className='ms-4 text-white'>
                <FaUserPlus/> 
                <span className='ms-2'>Add Doctor</span>
            </NavLink>
            <NavLink exact to='' className='ms-4 text-white '>
                <FaCog/> 
                <span className='ms-2'>Setting</span> 
            </NavLink>
            <NavLink exact to='/' className='ms-4 text-white  ' style={{marginTop:'200px'}}>
                <FiLogOut/>
                <span className='ms-2'>Log Out</span > 
            </NavLink>

        </div>
    );
};

export default Sidebar;